// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.autopay.Bill
import org.mifospay.core.model.autopay.BillStatus
import org.mifospay.core.model.autopay.RecurrencePattern

@OptIn(InternalKtorfitApi::class)
public class _BillServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : BillService {
  override fun getAllBills(clientId: Long): Flow<List<Bill>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "bills")
        clientId?.let{ parameter("clientId", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<Bill>>>(),)!! 
  }

  override suspend fun getBillById(billId: String): Flow<Bill> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "bills/${"$billId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Bill>>(),)!! 
  }

  override suspend fun createBill(bill: Bill): Flow<Bill> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "bills")
        }
        setBody(bill) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Bill>>(),)!! 
  }

  override suspend fun updateBill(billId: String, bill: Bill): Flow<Bill> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "bills/${"$billId".encodeURLPath()}")
        }
        setBody(bill) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Bill>>(),)!! 
  }

  override suspend fun deleteBill(billId: String): Flow<Unit> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_baseUrl + "bills/${"$billId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Unit>>(),)!! 
  }

  override suspend fun getBillsByStatus(status: BillStatus): Flow<List<Bill>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "bills/status/${"$status".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<Bill>>>(),)!! 
  }

  override suspend fun getBillsByBillerId(billerId: String): Flow<List<Bill>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "bills/biller/${"$billerId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<Bill>>>(),)!! 
  }

  override suspend fun getBillsByRecurrencePattern(pattern: RecurrencePattern): Flow<List<Bill>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "bills/recurrence/${"$pattern".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<Bill>>>(),)!! 
  }

  override suspend fun searchBillsByName(query: String): Flow<List<Bill>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "bills/search")
        query?.let{ parameter("query", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<Bill>>>(),)!! 
  }

  override suspend fun getOverdueBills(): Flow<List<Bill>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "bills/overdue")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<Bill>>>(),)!! 
  }

  override suspend fun getUpcomingBills(fromDate: Long, toDate: Long): Flow<List<Bill>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "bills/upcoming")
        fromDate?.let{ parameter("fromDate", "$it") }
        toDate?.let{ parameter("toDate", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<Bill>>>(),)!! 
  }

  override suspend fun updateBillStatus(billId: String, status: BillStatus): Flow<Bill> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "bills/${"$billId".encodeURLPath()}/status")
        status?.let{ parameter("status", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Bill>>(),)!! 
  }

  override fun getBillStatistics(clientId: Long): Flow<BillStatisticsResponse> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "bills/statistics")
        clientId?.let{ parameter("clientId", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<BillStatisticsResponse>>(),)!! 
  }

  override suspend fun clearAllBills(): Flow<Unit> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_baseUrl + "bills")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Unit>>(),)!! 
  }
}

public class _BillServiceProvider : ClassProvider<BillService> {
  override fun create(_ktorfit: Ktorfit): BillService = _BillServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createBillService(): BillService = _BillServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
